const apiWorkflow = {
  'get-list': {
    method: 'post',
    url: '/admincp/workflow/list'
  },
  add: {
    method: 'post',
    url: '/admincp/workflow'
  },
  delete: {
    method: 'delete',
    url: '/admincp/workflow'
  },
  edit: {
    method: 'put',
    url: '/admincp/workflow/ID'
  }
}

export default {
  ...apiWorkflow
}
